<template>
	<div v-if="isActive || selectedStoreId > 0" class="list-group col-xs-12">
		<div v-for="(store) in storesToLoop" :key="store.id">
			<storeItem
				v-if="! hideStore(store.id)"
				:storeId="store.id"
				:cartRows="cartRows"
				:location="location"
				:isActive="isActive"
				:selectedStoreId="selectedStoreId"
				:storeDistance="getStoreDistance(store)"
				:class="{ disabled: stopCC(store.id) || eolAvailability(store.id) }"
				:stockStatus.sync="stockMap[store.id]"
				@click.native="selectStore(store, true)"
			/>
			<div v-if="isActive && ! hideStore(store.id)" class="col-xs-12 divider" :class="{'border-bottom': !(selectedStoreId === store.id)}" />
		</div>
		<div v-if="isActive && ! allStores" class="list-group-item col-xs-12" @click="allStores = true">
			<span class="glyphicon glyphicon-chevron-down" />
			<a class="pl-5">Visa alla butiker</a>
		</div>
		<div v-else-if="isActive && allStores" class="list-group-item col-xs-12" @click="[allStores = false, shiftStore = true]">
			<span class="glyphicon glyphicon-chevron-up" />
			<a class="pl-5">Visa färre butiker</a>
		</div>
	</div>
</template>

<script>

import { cloneDeep } from 'lodash';
import bus from 'eventbus';
import { formatDistance, geoDistSort } from 'utils';
import storeItem from './store-item';
import { selectCheckoutOption } from 'gtm';
import { mapState, mapGetters } from 'vuex';
import { getStore } from 'datastore/i18n';

const NUM_STORES = 6;

export default {
	data () {
		return {
			selectedStoreId: null,
			selectedStoreInfo: null,
			allStores: false,
			shiftStore: false,
			firstLoop: false,
			latestStoreArray: [],
			formatDistance,
			geoDistSort,
			fruangen: 16,
			stockMap: {},
		};
	},
	props: {
		value: {
			required: true,
		},
		cartRows: {
			type: Array,
			required: true,
		},
		location: {
			type: Object,
			required: true,
		},
		isActive: {
			type: Boolean,
			default: false,
		},
		selectedZipCode: {
			type: Number,
			required: false,
			default: 0,
		},
		limitedByEol: {
			type: Boolean,
			default: false,
		},
		eolStockPlaces: {
			type: Object,
			default: () => {},
			required: false,
		},
		eolProducts: {
			type: Array,
			default: () => [],
			required: false,
		},
	},
	components: {
		storeItem,
	},
	mounted () {
		if (this.value) {
			this.selectedStoreId = this.stopCC(this.value) || this.eolAvailability(this.value) ? null : this.value;
			bus.$emit('shipping-updated', 0);
		}
		if (this.selectedStoreId) {
			this.selectedStoreInfo = getStore(this.selectedStoreId);
			this.firstLoop = true;
		}
		if (! this.selectedStoreId) {
			let store = null;
			for (let i = 0; i < this.storesToLoop.length; i++) {
				if (! this.stopCC(this.storesToLoop[i].id) || this.eolAvailability(this.storesToLoop[i].id)) {
					store = this.storesToLoop[i];
					break;
				}
			}
			/**
			 * If we cant find a store to pre select in
			 * this.storesLoop, we have to show all stores
			 * and pick one of them instead
			 */
			if (! store) {
				this.allStores = true;
				for (let i = 0; i < this.stores.length; i++) {
					if (! this.stopCC(this.stores[i].id) || this.eolAvailability(this.stores[i].id)) {
						store = this.stores[i];
						break;
					}
				}
			}
			this.selectedStoreId = store.id;
			this.$emit('update:selectedStoreId', store.id);
		}
		for (store in this.stores) {
			this.stockMap = {
				[store]: false,
				...this.stockMap,
			}
		}
		bus.$on('selectFirstStore', this.selectStore);
	},
	beforeDestroy () {
		bus.$off('selectFirstStore', this.selectStore);
	},
	methods: {
		selectStore(store = null, click = false) {
			if (this.stopCC(store.id) || this.eolAvailability(store.id)) {
				return;
			}

			if (store === null) {
				store = ! this.stopCC(this.storesToLoop[0].id) ? this.storesToLoop[0] : ! this.stopCC(this.storesToLoop[1].id) ? this.storesToLoop[1] : this.storesToLoop[2];
			}

			this.selectedStoreId = store.id;
			if (this.isActive) {
				this.$emit('update:selectedStoreId', store.id);
				bus.$emit('shipping-updated', 0);
				if (click) {
					selectCheckoutOption(2, 'Butik: ' + store.name);
				}
			} else {
				bus.$emit('stepUpdated', 2, null);
			}
		},
		getStoreDistance (store) {
			return this.sortedStores && store.dist ? '(' + formatDistance(store.dist) + ')' : '';
		},
		checkIfHidden (stores) {
			if (! this.selectedStoreId) {
				return false;
			}
			if (this.latestStoreArray) {
				stores = this.latestStoreArray.map(s => s.id);
			} else {
				stores = this.allStores ? stores : stores.slice(0, NUM_STORES);
			}
			let storeIsHidden = true;
			const selectedStoreId = this.selectedStoreId;
			stores.forEach(store => {
				if (store === selectedStoreId || store.id === selectedStoreId) {
					storeIsHidden = false;
				}
			});

			return storeIsHidden;
		},
		topStores () {
			const stores = this.userSettings.myStores.slice();
			let suggestedStores = this.user.storeSuggestions;
			const isHidden = this.checkIfHidden(suggestedStores);
			let fillStores = this.allStores ? suggestedStores.length + 1 : NUM_STORES - stores.length;
			if (this.firstLoop && this.value || this.selectedStoreId && this.shiftStore || ! this.isActive || isHidden) {
				suggestedStores = suggestedStores.filter(storeId => storeId !== this.selectedStoreId || this.value);
				suggestedStores.unshift(this.selectedStoreId);
			}
			this.shiftStore = false;
			for (let i = 0; i < suggestedStores.length && fillStores > 0; i++) {
				const store = suggestedStores[i];
				if (stores.includes(store)) continue;
				if (this.stockMap[store+'']) {
					stores.push(store);
					fillStores--;
				}
			}

			for (let i = 0; i < suggestedStores.length && fillStores > 0; i++) {
				const store = suggestedStores[i];
				if (stores.includes(store)) continue;

				stores.push(store);
				fillStores--;
			}
			this.firstLoop = false;
			this.latestStoreArray = stores.map(storeId => getStore(storeId)).filter(store => !! store);
			return this.latestStoreArray;
		},
		sortedStores () {
			let sortedStores = geoDistSort(this.location, this.stores);
			if (sortedStores) {
				const isHidden = this.checkIfHidden(sortedStores);
				if (this.firstLoop && this.value || this.selectedStoreId && this.shiftStore || ! this.isActive || isHidden) {
					sortedStores = sortedStores.filter(store => store.id !== (this.selectedStoreId || this.value));
					sortedStores.unshift(getStore(this.selectedStoreId));
				}
				this.shiftStore = false;
				this.firstLoop = false;
				this.latestStoreArray = sortedStores;
				return this.allStores ? sortedStores : sortedStores.slice(0, NUM_STORES);
			}
			return null;
		},
		stopCC (storeId) {
			const today = new Date();
			let stopCC = false;

			switch (storeId) {
				case this.fruangen:
					const fruangenStop = new Date('2025/12/31 00:00:02');
					stopCC = today > fruangenStop;
					break;
				default:
					break;
			}

			return stopCC;
		},
		hideStore (storeId) {
			const today = new Date();
			let hide = false;

			switch (storeId) {
				case this.fruangen:
					const fruangenHide = new Date('2026/01/11 00:00:02');
					hide = today > fruangenHide;
					break;
				default:
					break;
			}

			return hide;
		},
		// returns true if store is disabled
		eolAvailability (storeId) {
			return this.eolProducts.length && ! this.eolSharedStores.includes(storeId.toString());
		},
	},
	computed: {
		storesToLoop () {
			if (this.location && this.location.lat) {
				return  this.sortedStores();
			} else if (this.allStores) {
				return this.stores;
			} else {
				return this.topStores();
			}
		},
		stores () {
			const stores = this.$store.state.i18n.stores;
			if (! stores) return null;
			let storeArr = [];
			if (this.latestStoreArray) {
				storeArr = this.latestStoreArray.slice(0, 5);
				let sortedWithoutTop = [];
				Object.entries(stores).forEach((store) => {
					if (storeArr.filter(function(s) {return s.id == store[1].id;}).length === 0 && store[1].name !== 'Butiker') {
						storeArr.push(store[1]);
					}
				});
				return storeArr;
			} else {
				for (const storeId in stores) {
					if (stores[storeId].name !== 'Butiker') {
						storeArr.push(cloneDeep(stores[storeId]));
					}
				}
				return storeArr;
			}
		},
		eolSharedStores () {
			const stores = [];
			if (this.limitedByEol && this.eolProducts.length) {
				const allStores = [];

				// Put all stores from all products in array
				this.eolProducts.forEach((product) => {
					allStores.push(...this.eolStockPlaces[product].filter(stock => stock !== 'web'));
				});

				allStores.forEach(store => {
					/**
					 * Check that the store occurs the same number of times in array
					 * as the number of products, if true all products are
					 * availble in specific store
					 */
					if (allStores.filter(s => s === store).length === this.eolProducts.length
						&& ! stores.includes(store)) {
						stores.push(store);
					}
				});
			}
			return stores;
		},
		...mapState({
			userSettings: state => state.userSettings,
			user: state => state.user,
		}),
		...mapGetters ({
			isLoggedIn: 'user/isLoggedIn',
		}),
	},
	watch: {
		value () {
			if (this.selectedStoreId != this.value) {
				this.selectedStoreId = this.value;
			}
		},
		storesToLoop () {
			if (this.checkIfHidden(this.storesToLoop)) {
				this.selectStore(this.storesToLoop[0]);
			}
		},
		selectedStoreId (to) {
			this.selectedStoreInfo = getStore(to);
			this.$emit('storeStock', this.stockMap[to]);
		},
		stockMap () {
			this.$emit('storeStock', this.stockMap[this.selectedStoreId]);
		},
		selectedStoreInfo (to) {
			this.$emit('update:stepSelection', 'Butik: ' + to.name);
		},
	},
};
</script>
